import { render, staticRenderFns } from "./CadastroCotacaoFornecedores.vue?vue&type=template&id=9e5d06a6&"
import script from "./CadastroCotacaoFornecedores.vue?vue&type=script&lang=js&"
export * from "./CadastroCotacaoFornecedores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports